import { all } from 'redux-saga/effects';
import accountSaga from './account';
import ssoSaga from './sso';
import toolsSaga from './tools';

export default function* rootSaga() {
  yield all([...accountSaga, ...ssoSaga, ...toolsSaga]);
}
